import {
  LOAD_ONGOING,
  LOAD_SUCCESS,
  LOAD_AVALIABLE,
  LOAD_AVALIABLE_FOR_EDIT,
  LOAD_ALL,
  UPDATE_DATA_TRICKET,
  LOAD_DATA_VEHICLE_FOR_VIEW,
  NEW_LOAD_DATA_DASHBORAD,
  RECALCULATOR_AREA_NOT_COVERED,
  CALCULATOR_DELIVERRY_OUTSIDE_THE_AREA,
  CREATE_LOG_REQUEST_CHANGE_DEST_LOCATION,
  ISUPPLY_DASHBOARD_CLOSE_WORK,
  REMOVE_LISTS,
  LOAD_DATA_ISUPPLY_DASHBOARD,
  SOURCE_QUALITY_CONTROL_LOG_DETAIL,
  ISUPPLY_DASHBOARD_LOAD_EVALUATION_FORM,
  ISUPPLY_DASHBOARD_SUBMIT_EVALUATION_FORM,
  ISUPPLY_DASHBOARD_CHANGE_ORIGIN_LOCATION_MULTIPLE,
  ISUPPLY_DASHBOARD_LOAD_DIVISION,
  ISUPPLY_DASHBOARD_LOAD_DEPARTMENT,
  ISUPPLY_DASHBOARD_LOAD_SECTION,
  ISUPPLY_DASHBOARD_LOAD_PLANT,
  ISUPPLY_DASHBOARD_RESEND_GR,
  ISUPPLY_DASHBOARD_CHANGE_DEST_SEARCH_TICKET,
  ISUPPLY_DASHBOARD_EVALUATION_FORM_CHANGE_DEST,
  ISUPPLY_DASHBOARD_EXPORT_DP,
  ISUPPLY_SOURCE_READINESS_FOR_MANAGE,
  UPDATE_ISUPPLY_SOURCE_READINESS,
  CHECK_ISUPPLY_SOURCE_READINESS_CONFIRM,
} from './actions'

const initialState = {
  ongoing_lists: [],
  ongoing_total: 0,
  ongoing_quantity: 0,
  success_lists: [],
  success_total: 0,
  success_quantity: 0,
  available_lists: [],
  available_total: 0,
  available_quantity: 0,

  quantity: 0,
  quantity_success: 0,
  work_total: 0,
  work_success: 0,
  no_status: 0,
  wait_for_the_queue: 0,
  receive_the_goods: 0,
  go_to: 0,
  wait_pour: 0,

  listsDataForEdit: [],
  loading: false,
  loadingForEdit: false,
  checkLoaddataforedit: true,
  actionOfEdit: '',

  listsDataForView: [],
  loadingForView: false,
  checkLoaddataforview: true,
  draw: -1,

  data_for_new_dashborad: [],
  data_for_new_dashborad_new: [],
  data_for_new_dashborad_new_total: 0,
  total_count: 0,
  count: 0,

  // *Start ดึงข้อมูลมาแสดงหน้า Dashboard การขนส่งวัตถุดิบ
  data_for_isupply_dashboard: [],
  data_count: 0,
  data_all_count: 0,
  // *End ดึงข้อมูลมาแสดงหน้า Dashboard การขนส่งวัตถุดิบ

  // *detail ประเมินคุณภาพ (ต้นแหล่ง)
  quality_control_lists_detail: [],
  quality_control_check_detail: false,

  // *load form ประเมินคุณภาพสินค้า
  evaluation_form: [],
  loading_evaluation_form: false,
  evaluation_form_isupply_do_id: '',

  // *submit form ประเมินคุณภาพสินค้า
  submit_form_evaluation: false,
  submit_form_evaluation_data: '',
  update_change_origin_location_multiple: false,

  // *loadข้อมูลสำหรับ filter
  division_list: [],
  check_division_list: false,

  department_list: [],
  check_department_list: false,

  section_list: [],
  check_section_list: false,

  plant_list: [],
  check_plant_list: false,

  // *ส่ง GR อีกครั้ง
  check_resend_gr: false,
  resend_gr_data: [],

  // *search ticket
  change_dest_search_ticket: [],
  check_change_dest_search_ticket: false,

  // *ประเมินสินค้ารับสินค้าเปลี่ยนปลายทาง
  evaluation_form_change_dest: [],
  check_evaluation_form_change_dest: false,

  // *export ข้อมูลเป็น DP
  export_dp: [],
  check_export_dp: false,

  source_readiness_info: null,
  source_readineass_loading: false,
  total_isupply_source_readiness: 0,
  total_confirm_isupply_source_readiness: 0,
  check_confirm_source_readineass_loading: false,
}

export default (state = initialState, action) => {
  switch (action.type) {
    case REMOVE_LISTS:
      return initialState

    case LOAD_ONGOING.REQUEST:
      const { loading } = action.payload
      return {
        ...state,
        loading: loading,
      }

    case LOAD_ONGOING.SUCCESS:
      return {
        ...state,
        ongoing_lists: action.payload.lists.data,
        check: false,
        ongoing_total: action.payload.lists.total,
        ongoing_quantity: action.payload.lists.quantity,
        loading: false,
        draw: Math.floor(Math.random() * 999 + 1),
      }

    case LOAD_SUCCESS.REQUEST:
      return {
        ...state,
        // loading: loading,
      }

    case LOAD_SUCCESS.SUCCESS:
      return {
        ...state,
        success_lists: action.payload.lists.data,
        check: false,
        success_total: action.payload.lists.total,
        success_quantity: action.payload.lists.quantity,
        loading: false,
        draw: Math.floor(Math.random() * 999 + 1),
      }

    case LOAD_AVALIABLE.SUCCESS:
      return {
        ...state,
        available_lists: action.payload.lists.data,
        check: false,
        available_total: action.payload.lists.total,
        available_quantity: action.payload.lists.quantity,
        loading: false,
        draw: Math.floor(Math.random() * 999 + 1),
      }

    case LOAD_ALL.SUCCESS:
      return {
        ...state,
        quantity: action.payload.lists.quantity,
        quantity_success: action.payload.lists.quantity_success,
        work_total: action.payload.lists.work_total,
        work_success: action.payload.lists.work_success,
        no_status: action.payload.lists.no_status,
        wait_for_the_queue: action.payload.lists.wait_for_the_queue,
        receive_the_goods: action.payload.lists.receive_the_goods,
        go_to: action.payload.lists.go_to,
        wait_pour: action.payload.lists.wait_pour,
      }

    case LOAD_AVALIABLE_FOR_EDIT.REQUEST:
      return {
        ...state,
        listsDataForEdit: [],
        loadingForEdit: action.payload.loading,
        checkLoaddataforedit: true,
        actionOfEdit: action.payload.action_type,
      }

    case LOAD_AVALIABLE_FOR_EDIT.SUCCESS:
      return {
        ...state,
        listsDataForEdit: action.payload.lists.data,
        loadingForEdit: false,
        checkLoaddataforedit: false,
      }

    // the ticket API failed (500): stop the drawer spinner
    case LOAD_AVALIABLE_FOR_EDIT.FAILURE:
      return {
        ...state,
        listsDataForEdit: [],
        loadingForEdit: false,
        checkLoaddataforedit: false,
      }

    case LOAD_DATA_VEHICLE_FOR_VIEW.REQUEST:
      return {
        ...state,
        loadingForView: action.payload.data.loading,
        checkLoaddataforview: true,
      }

    case LOAD_DATA_VEHICLE_FOR_VIEW.SUCCESS:
      return {
        ...state,
        listsDataForView: action.payload.lists.data,
        loadingForView: false,
        checkLoaddataforview: false,
      }

    case UPDATE_DATA_TRICKET.REQUEST:
      return {
        ...state,
        loadingForEdit: true,
      }

    case UPDATE_DATA_TRICKET.SUCCESS:
      return {
        ...state,
        loadingForEdit: false,
      }

    case NEW_LOAD_DATA_DASHBORAD.REQUEST:
      return {
        ...state,
        loading: action.payload.loading,
      }

    case NEW_LOAD_DATA_DASHBORAD.SUCCESS:
      return {
        ...state,
        data_for_new_dashborad: action.payload.lists,
        loading: false,
      }

      let new_date = []
      let count = 0
      if (action.payload.page > 0) {
        new_date = state.data_for_new_dashborad_new.concat(
          action.payload.lists.data
        )
        count = state.count + action.payload.lists.count
      } else {
        new_date = action.payload.lists.data
        count = action.payload.lists.count
      }
      return {
        ...state,
        data_for_new_dashborad_new: new_date,
        data_for_new_dashborad_new_total: action.payload.lists.total,
        total_count: action.payload.lists.total_count,
        count: count,
        loading: false,
      }
    // *Start ดึงข้อมูลมาแสดงหน้า Dashboard การขนส่งวัตถุดิบ
    case LOAD_DATA_ISUPPLY_DASHBOARD.REQUEST:
      return {
        ...state,
        loading: action.payload.loading,
      }

    case LOAD_DATA_ISUPPLY_DASHBOARD.SUCCESS:
      let last_data = state.data_for_isupply_dashboard
      let newer_data = action.payload.lists.data
      let data_all = []
      let data_count = 0

      if (action.payload.offset > 0) {
        // ถ้าข้อมูลเดิมมีอยู่แล้ว ให้เช็คก่อนว่าซ้ำกับข้อมูลใหม่มั้ย
        if (last_data.length > 0) {
          let old_data = last_data[last_data.length - 1]
          let new_data = newer_data[0]
          // ?เช็คว่าข้อมูลนี้มี main_title_id ตรงกันหรือไม่
          if (old_data.main_title_id == new_data.main_title_id) {
            old_data = {
              ...old_data,
              main_go_to: old_data.main_go_to + new_data.main_go_to,
              main_no_status: old_data.main_no_status + new_data.main_no_status,
              main_sum_status:
                old_data.main_sum_status + new_data.main_sum_status,
              main_work_success:
                old_data.main_work_success + new_data.main_work_success,
            }

            new_data.main_data.forEach((newer) => {
              let match = 0
              old_data.main_data.forEach((old) => {
                // ?จัดกลุ่มโดย บริษัทขนส่ง
                // TODO: เช็คว่าปลายทางและวัตถุดิบตรงกันหรือไม่
                // ?จัดกลุ่มโดย ปลายทางหรือต้นทาง
                // TODO: เช็คว่าชื่อบริษัทและวัตถุดิบตรงหรือไม่
                if (
                  ((action.payload.group_by == 'vendor' ||
                    action.payload.group_by == 'material') &&
                    old.dest_locations_id == newer.dest_locations_id &&
                    old.material_id == newer.material_id) ||
                  ((action.payload.group_by == 'plant' ||
                    action.payload.group_by == 'mill') &&
                    old.vendor_id == newer.vendor_id &&
                    old.material_id == newer.material_id)
                ) {
                  old.no_status = old.no_status + newer.no_status
                  old.go_to = old.go_to + newer.go_to
                  old.sum_status = old.sum_status + newer.sum_status
                  old.work_success = old.work_success + newer.work_success
                  old.data_sup_header = old.data_sup_header.concat(
                    newer.data_sup_header
                  )
                  match = 1
                }
              })

              // ?ไม่มีข้อมูลที่ซ้ำกับข้อมูลก่อนหน้า ให้เพิ่มต่อจากข้อมูลก่อนหน้า
              if (match == 0) {
                old_data = {
                  ...old_data,
                  main_data: old_data.main_data.concat(newer),
                }
              }
            })

            // เปลี่ยนค่า Array ในตำแหน่งสุดท้ายใหม่
            last_data[last_data.length - 1] = old_data
            // ลบค่าตำแหน่งแรกใน newer_data ออกเนื่องจากเอาไปรวมกันเรียบร้อยแล้ว
            newer_data.shift()
          }
        }
        //รวมข้อมูลเก่าและใหม่เข้าด้วยกัน
        data_all = last_data.concat(newer_data)
        data_count =
          action.payload.check_load == 1
            ? state.data_count
            : state.data_count + action.payload.lists.data_count
      } else {
        data_all = newer_data
        data_count =
          action.payload.check_load == 1
            ? state.data_count
            : action.payload.lists.data_count
      }
      return {
        ...state,
        data_for_isupply_dashboard: data_all,
        data_count: data_count,
        data_all_count: action.payload.lists.data_all_count,
        loading: false,
      }
    // *End ดึงข้อมูลมาแสดงหน้า Dashboard การขนส่งวัตถุดิบ

    case RECALCULATOR_AREA_NOT_COVERED.REQUEST:
      return {
        ...state,
        loading: true,
      }

    case CALCULATOR_DELIVERRY_OUTSIDE_THE_AREA.REQUEST:
      return {
        ...state,
        loading: true,
      }

    case CREATE_LOG_REQUEST_CHANGE_DEST_LOCATION.REQUEST:
      return {
        ...state,
        loading: true,
      }

    case ISUPPLY_DASHBOARD_CLOSE_WORK.REQUEST:
      return {
        ...state,
        loading: true,
      }
    case ISUPPLY_DASHBOARD_CLOSE_WORK.FALSE:
      return {
        ...state,
        loading: false,
      }

    case ISUPPLY_DASHBOARD_CLOSE_WORK.SUCCESS:
      return {
        ...state,
        loading: false,
      }
    case SOURCE_QUALITY_CONTROL_LOG_DETAIL.REQUEST:
      return {
        ...state,
        quality_control_lists_detail: [],
        quality_control_check_detail: true,
      }
    case SOURCE_QUALITY_CONTROL_LOG_DETAIL.SUCCESS:
      return {
        ...state,
        quality_control_lists_detail: action.payload.lists,
        quality_control_check_detail: false,
      }

    case ISUPPLY_DASHBOARD_LOAD_EVALUATION_FORM.REQUEST:
      return {
        ...state,
        loading_evaluation_form: true,
        evaluation_form: [],
        evaluation_form_isupply_do_id: '',
      }

    case ISUPPLY_DASHBOARD_LOAD_EVALUATION_FORM.SUCCESS:
      return {
        ...state,
        loading_evaluation_form: false,
        evaluation_form: action.payload.lists,
        evaluation_form_isupply_do_id: action.payload.isupply_do_id,
      }

    case ISUPPLY_DASHBOARD_SUBMIT_EVALUATION_FORM.REQUEST:
      return {
        ...state,
        submit_form_evaluation: true,
        submit_form_evaluation_data: '',
      }
    case ISUPPLY_DASHBOARD_SUBMIT_EVALUATION_FORM.SUCCESS:
      return {
        ...state,
        submit_form_evaluation: false,
        submit_form_evaluation_data: action.payload.lists,
      }
    case ISUPPLY_DASHBOARD_CHANGE_ORIGIN_LOCATION_MULTIPLE.REQUEST:
      return {
        ...state,
        update_change_origin_location_multiple: true,
      }

    case ISUPPLY_DASHBOARD_CHANGE_ORIGIN_LOCATION_MULTIPLE.SUCCESS:
      return {
        ...state,
        update_change_origin_location_multiple: false,
      }

    case ISUPPLY_DASHBOARD_LOAD_DIVISION.REQUEST:
      return {
        ...state,
        division_list: [],
        check_division_list: true,
      }
    case ISUPPLY_DASHBOARD_LOAD_DIVISION.SUCCESS:
      return {
        ...state,
        division_list: action.payload.lists,
        check_division_list: false,
      }
    case ISUPPLY_DASHBOARD_LOAD_DEPARTMENT.REQUEST:
      return {
        ...state,
        department_list: [],
        check_department_list: true,
      }
    case ISUPPLY_DASHBOARD_LOAD_DEPARTMENT.SUCCESS:
      return {
        ...state,
        department_list: action.payload.lists,
        check_department_list: false,
      }
    case ISUPPLY_DASHBOARD_LOAD_SECTION.REQUEST:
      return {
        ...state,
        section_list: [],
        check_section_list: true,
      }
    case ISUPPLY_DASHBOARD_LOAD_SECTION.SUCCESS:
      return {
        ...state,
        section_list: action.payload.lists,
        check_section_list: false,
      }
    case ISUPPLY_DASHBOARD_LOAD_PLANT.REQUEST:
      return {
        ...state,
        plant_list: [],
        check_plant_list: true,
      }
    case ISUPPLY_DASHBOARD_LOAD_PLANT.SUCCESS:
      return {
        ...state,
        plant_list: action.payload.lists,
        check_plant_list: false,
      }

    case ISUPPLY_DASHBOARD_RESEND_GR.REQUEST:
      return {
        ...state,
        check_resend_gr: true,
        resend_gr_data: [],
      }
    case ISUPPLY_DASHBOARD_RESEND_GR.SUCCESS:
      return {
        ...state,
        check_resend_gr: false,
        resend_gr_data: action.payload.lists,
      }
    case ISUPPLY_DASHBOARD_CHANGE_DEST_SEARCH_TICKET.REQUEST:
      return {
        ...state,
        change_dest_search_ticket: [],
        check_change_dest_search_ticket: true,
      }
    case ISUPPLY_DASHBOARD_CHANGE_DEST_SEARCH_TICKET.SUCCESS:
      return {
        ...state,
        change_dest_search_ticket: action.payload.lists,
        check_change_dest_search_ticket: false,
      }
    case ISUPPLY_DASHBOARD_EVALUATION_FORM_CHANGE_DEST.REQUEST:
      return {
        ...state,
        evaluation_form_change_dest: [],
        check_evaluation_form_change_dest: true,
      }
    case ISUPPLY_DASHBOARD_EVALUATION_FORM_CHANGE_DEST.SUCCESS:
      return {
        ...state,
        evaluation_form_change_dest: action.payload.lists,
        check_evaluation_form_change_dest: false,
      }

    case ISUPPLY_DASHBOARD_EXPORT_DP.REQUEST:
      return {
        ...state,
        export_dp: [],
        check_export_dp: true,
      }
    case ISUPPLY_DASHBOARD_EXPORT_DP.SUCCESS:
      return {
        ...state,
        export_dp: action.payload.lists,
        check_export_dp: false,
      }

    case CHECK_ISUPPLY_SOURCE_READINESS_CONFIRM.REQUEST:
      return {
        ...state,
        check_confirm_source_readineass_loading: true,
        total_isupply_source_readiness: 0,
        total_confirm_isupply_source_readiness: 0,
      }

    case CHECK_ISUPPLY_SOURCE_READINESS_CONFIRM.SUCCESS:
      return {
        ...state,
        check_confirm_source_readineass_loading: false,
        total_isupply_source_readiness:
          action.payload.data.total_isupply_source_readiness,
        total_confirm_isupply_source_readiness:
          action.payload.data.total_confirm_isupply_source_readiness,
      }

    case ISUPPLY_SOURCE_READINESS_FOR_MANAGE.REQUEST:
      return {
        ...state,
        source_readiness_info: null,
        source_readineass_loading: true,
      }

    case ISUPPLY_SOURCE_READINESS_FOR_MANAGE.SUCCESS:
      return {
        ...state,
        source_readiness_info: action.payload.lists,
        source_readineass_loading: false,
      }

    case UPDATE_ISUPPLY_SOURCE_READINESS.REQUEST:
      return {
        ...state,
        source_readineass_loading: true,
      }

    case UPDATE_ISUPPLY_SOURCE_READINESS.SUCCESS:
      return {
        ...state,
        source_readiness_info: null,
        source_readineass_loading: false,
      }

    default:
      return state
  }
}
